var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCalendarTime = function SvgCalendarTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.458 17.417a3.963 3.963 0 0 0 3.959-3.959A3.963 3.963 0 0 0 13.458 9.5 3.963 3.963 0 0 0 9.5 13.458a3.963 3.963 0 0 0 3.958 3.959zM1.583 14.25H7.98a5.58 5.58 0 0 1-.063-.792c0-2.786 2.068-5.092 4.75-5.478v-.855H1.583v7.125zM3.167 3.167H1.583v2.375h11.084V3.167h-1.584V4.75H9.5V3.167H4.75V4.75H3.167V3.167zM14.25 7.98c2.681.386 4.75 2.692 4.75 5.478A5.549 5.549 0 0 1 13.458 19a5.542 5.542 0 0 1-4.998-3.167H0V1.583h3.167V0H4.75v1.583H9.5V0h1.583v1.583h3.167V7.98zm0 2.312v2.839l1.351 1.351-1.119 1.12-1.815-1.816v-3.494h1.583z"
  })));
};

export default SvgCalendarTime;